import React from 'react';
import { Button } from '../../../../../../../../components/atoms/Button';
import { Icon } from '../../../../../../../atoms';
import { EmptyCustomMetricsImage } from './EmptyCustomMetricsImage';
import makeStyles from './EmptyCustomMetricsScreen.styles';
export const EmptyCustomMetricsScreen = (props) => {
    const css = makeStyles();
    return (React.createElement("div", { className: css.wrapper },
        React.createElement("div", { className: css.imageWrapper },
            React.createElement(EmptyCustomMetricsImage, null)),
        React.createElement("div", { className: css.title }, "Time to create your first Custom Metric"),
        React.createElement("div", { className: css.description }, "Custom metrics provide you with actionable insights, tailored just for you."),
        React.createElement("div", { className: css.button },
            React.createElement(Button, { onClick: props.onButtonClick, startIcon: React.createElement(Icon, null, "add"), variant: "outlined" }, "Create Custom Metric"))));
};
//# sourceMappingURL=EmptyCustomMetricsScreen.js.map